<template>
  <BrandTheme :theme="theme">
    <header class="fixed inset-x-0 top-0 z-10 bg-navbg p-4 shadow-md">
      <div class="flex h-30 w-full items-center overflow-hidden">
        <div class="mx-auto w-full p-4">
          <div class="-m-3 flex flex-wrap">
            <div class="w-5/12 shrink-0 p-3">
              <img
                class="mt-0 h-auto max-h-[300px] w-full max-w-[360px] object-contain"
                :src="logo"
                alt="accadis"
              />
            </div>
            <div class="grow" />
            <div class="min-w-0 flex-1 p-3">
              <div class="flex justify-center">
                <ProgressionCounter4k
                  v-if="time > 0"
                  :time="time"
                  :timeleft="timeleft"
                />
              </div>
            </div>
            <div class="grow" />

            <div class="w-5/12 shrink-0 p-3 pr-12 text-right">
              <div class="-m-3 flex flex-wrap justify-end">
                <div class="min-w-0 flex-1 self-center p-0 pt-6">
                  <div class="text-6xl font-normal text-navtext">
                    <slot name="title">
                      accadis <span class="font-bold">Infoanzeige</span>
                    </slot>
                  </div>
                </div>
                <div class="w-2/12 shrink-0 p-0 pl-5">
                  <img
                    v-if="image"
                    :src="image"
                    class="mt-3 mr-2 size-[120px] max-w-none object-contain"
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
    <div class="h-16" aria-hidden="true" />
  </BrandTheme>
</template>

<script lang="ts" setup>
import { brandThemes, resolveBrandThemeName } from '~/themes/brandThemes';

const props = defineProps({
  theme: { type: String, required: false, default: () => 'accadisHSTheme' },
  image: { type: String, required: true },
  time: { type: Number, required: false, default: () => 10 },
  timeleft: { type: Number, required: false, default: () => 10 },
});

const theme = computed(() => props.theme);
const image = computed(() => props.image);
const time = computed(() => props.time);
const timeleft = computed(() => props.timeleft);

const logo = computed(
  () => brandThemes[resolveBrandThemeName(theme.value)].assets.logo
);
</script>
